export default __webpack_public_path__ + "static/media/46w.d791f362.svg";